var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"btn btn-outline-primary my-2",attrs:{"type":"button"},on:{"click":function($event){return _vm.changeView(1)}}},[_vm._v("\n        Volver\n    ")]),_vm._v(" "),_c('h1',[_vm._v("Show")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.categories))])])
}
var staticRenderFns = []

export { render, staticRenderFns }